<template>
 <div>
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
        <div class="formItemBox">
        <el-form-item label="上线时间" class="item2" >
          <el-date-picker
              v-model="searchFrom.sbTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="下线时间" class="item2" >
          <el-date-picker
              v-model="searchFrom.xbTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="司机姓名:">
          <el-input placeholder="" v-model="searchFrom.driverName" ></el-input>
        </el-form-item>
        <el-form-item label="车辆号牌:">
          <el-input placeholder="" v-model="searchFrom.vhcNo" ></el-input>
        </el-form-item>
        <el-form-item label="流水编号:">
          <el-input placeholder="" v-model="searchFrom.workNo" ></el-input>
        </el-form-item>
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox">
            <el-button type="primary"  v-if="btnFlg[0]"  size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary"   size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <!-- <el-button type="primary" v-if="btnFlg[1]"  @click="exportFn" size="mini" :disabled="isDisable">导出</el-button> -->
            <!-- <el-button type="primary" v-if="btnFlg[2]"  @click="addFn" size="mini" >上线</el-button> -->
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading" class="tableComent"    bordersize="mini"  @selection-change="selectGoods" @row-click="handleRowClick"
         style="width: 100%" height="100%"  center border >
       <el-table-column type="selection" width="55"></el-table-column>
       <el-table-column  type="index" width="55" label="序号"></el-table-column>
       <el-table-column label="操作" width="120" >
          <template slot-scope="scope">
            <div>
              <el-button  type="text" size="mini" v-if="btnFlg[1]" @click="editFn(scope.row,1)">修改</el-button>
              <el-button  type="text" size="mini" v-if="btnFlg[2]" @click="delFn(scope.row)">删除</el-button>
              <el-button  type="text" size="mini" v-if="btnFlg[3]&&scope.row.attendanceStates=='0'" @click="editFn(scope.row,2)">下线</el-button>
            </div>
          </template>
        </el-table-column>
       <el-table-column prop="workNo" width="200"  :show-overflow-tooltip="true" :formatter="formatterRowEmpty" label="流水号"></el-table-column>
       <el-table-column prop="attendanceStates" width="80"  :show-overflow-tooltip="true" :formatter="formatterRowEmpty"   label="状态">
        <template slot-scope="scope">
          <div>
            <div>{{['已上线','已下线'][scope.row.attendanceStates]}}</div>
          </div>
        </template>
       </el-table-column>
       <el-table-column prop="driverName" width="80"  :show-overflow-tooltip="true" :formatter="formatterRowEmpty"   label="司机"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="vhcNo" label="车牌号" align="center" width="100"> </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="teamOrgName" label="小队" align="center" width="120"> </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="sbKilometres" label="接车公里数(km)" align="center"  width="130"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="sbElectricityQuantity" label="接车电量(%)" min-width="110" :formatter="formatterRowEmpty"></el-table-column>
         <el-table-column :show-overflow-tooltip="true" prop="sbHydrogenQuantity" label="接车氢量(%)" min-width="110" :formatter="formatterRowEmpty"></el-table-column>
         <el-table-column :show-overflow-tooltip="true" prop="sbTime" label="上线时间" min-width="170"  :formatter="dateTimeFormat"></el-table-column>
         <el-table-column :show-overflow-tooltip="true" prop="xbKilometres" label="还车公里数(km)" min-width="130" :formatter="formatterRowEmpty"></el-table-column>
         <el-table-column :show-overflow-tooltip="true" prop="xbElectricityQuantity" label="还车电量(%)" min-width="120" :formatter="formatterRowEmpty"></el-table-column>
         <el-table-column :show-overflow-tooltip="true" prop="xbHydrogenQuantity" label="还车氢量(%)" min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="xbTime" label="下线时间" min-width="170"  :formatter="dateTimeFormat"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" align="center" min-width="100"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" :formatter="dateTimeFormat" width="170"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加 -->
    <el-dialog  :title="title" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible.sync="addFlag" width="900px" center>
      <div>
        <el-form  :inline="true" :rules="rules"  ref="addForm" :model="addForm"  class="demo-form-inline jiaoyan"  label-width="110px"  size="mini"  >
          <div>
             <el-form-item label="司机姓名:" prop="driverName" class="width1" >
              <div  style="width:200px">{{addForm.driverName}}</div>
            </el-form-item>
            <el-form-item label="车牌号:" prop="driverName" class="width1" >
              <el-select  v-model="addForm.vhcNo" filterable placeholder="请选择" v-if="czFlag==1"  @change="changeCL">
                <el-option v-for="item in carList" :label="item.vhcNo" :value="item.vhcNo" :key="item.id"></el-option>
              </el-select>
              <span v-else>{{addForm.vhcNo}}</span>
            </el-form-item>
          </div>
          <div class="addressBox" v-if="czFlag==1">
            <h4 class="title">
              <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>上线信息</span>
            </h4>
            <div>
              <el-form-item label="接车公里数:" prop="sbKilometres" class="jiage"  >
                <el-input  placeholder="" v-number-input.float="3"   maxlength="20" v-model.trim="addForm.sbKilometres"></el-input>
                <span class="danwei">km</span>
              </el-form-item>
              <el-form-item label="接车电量:" prop="sbElectricityQuantity" class="jiage"  >
                <el-input  placeholder="" v-number-input.float="3"   maxlength="20" v-model.trim="addForm.sbElectricityQuantity"></el-input>
                <span class="danwei">%</span>
              </el-form-item>
              <el-form-item label="接车氢量:" prop="xbHydrogenQuantity" class="jiage"  >
                <el-input  placeholder="" v-number-input.float="3"   maxlength="20" v-model.trim="addForm.xbHydrogenQuantity"></el-input>
                <span class="danwei">%</span>
              </el-form-item>
              <el-form-item  label="上线时间:" prop="sbTime" >
                <el-date-picker
                  v-model="addForm.sbTime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="timestamp"
                  type="datetime"
                    placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
              <br>
              <el-form-item label="接车凭证:" prop="remark" v-if="addFlag" >
                <uploadImgs :imgList.sync='JCimgList' :max=2 @remove="remove"></uploadImgs>
              </el-form-item>

            </div>
          </div>
          <div class="addressBox" v-if="addForm.attendanceStates==1||czFlag==2">
            <h4 class="title">
              <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>下线信息</span>
            </h4>
            <div>
               <el-form-item label="还车公里数:" prop="xbKilometres" class="jiage"  >
                <el-input  placeholder="" v-number-input.float="3"   maxlength="20" v-model.trim="addForm.xbKilometres"></el-input>
                <span class="danwei">km</span>
              </el-form-item>
              <el-form-item label="还车电量:" prop="xbElectricityQuantity" class="jiage"  >
                <el-input  placeholder="" v-number-input.float="3"   maxlength="20" v-model.trim="addForm.xbElectricityQuantity"></el-input>
                <span class="danwei">%</span>
              </el-form-item>
              <el-form-item label="还车氢量:" prop="shebaoCosts" class="jiage"  >
                <el-input  placeholder="" v-number-input.float="3"   maxlength="20" v-model.trim="addForm.shebaoCosts"></el-input>
                <span class="danwei">%</span>
              </el-form-item>
              <el-form-item  label="下线时间:" prop="xbTime" >
                <el-date-picker
                  v-model="addForm.xbTime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="timestamp"
                  type="datetime"
                    placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
              <br>
              <el-form-item label="还车凭证:" prop="remark" v-if="addFlag" >
                <uploadImgs :imgList.sync='HCimgList' :max=2 @remove="remove"></uploadImgs>
              </el-form-item>

            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addFlag = false">取 消</el-button>
        <el-button type="primary" @click="saveFn()">确 定</el-button>
      </span>
    </el-dialog>

 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat, dateFormat1, toFixed } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { cDriverWorkRecordListPC, getFileShow, getCVehicleInfoListByDriverId, upWorkRecordPc, upWorkRecordForXbPc, delWorkRecord } from '@/api/vgs-driver2.0'
import uploadImgs from '@/views/newTMS/publicFiles/uploadImgs.vue'
export default {
  components: {
    uploadImgs
  },
  data () {
    return {
      title: '修改',
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      HWlist: [],
      loading: false,
      isDisable: false,
      sum: {},
      rules: {
        xbTime: [
          { required: true, message: '请选择下线时间', trigger: 'blur' }
        ],
        sbTime: [
          { required: true, message: '请选择上线时间', trigger: 'blur' }
        ],
        sbKilometres: [
          { required: true, message: '请输入接车公里数', trigger: 'blur' }
        ],
        sbElectricityQuantity: [
          { required: true, message: '请输入接车电量', trigger: 'blur' }
        ],
        xbKilometres: [
          { required: true, message: '请输入还车公里数', trigger: 'blur' }
        ],
        xbElectricityQuantity: [
          { required: true, message: '请输入还车电量', trigger: 'blur' }
        ]

      },
      czFlag: 1, // 1修改，2下线
      addFlag: false,
      addForm: { insuranceList: [{}] },
      XDList: [],
      XZList: [],
      carList: [],
      delBxIds: [],
      importDialog: false,
      bjData: {},
      delId: [],
      JCimgList: [],
      HCimgList: [],
      btnFlg: [],
      btnIdArr: ['00IM0C0100', '00IM0C0200', '00IM0C0300', '00IM0C0400']

    }
  },
  created () {
    this.$set(this.searchFrom, 'sbTime', this.getRecentWeekStartAndEnd())
    this.btnFlg = getBtn(this.btnIdArr, '/driverAttendance')
    this.searchFn()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 205) + 'px'
  },
  methods: {
    getRecentWeekStartAndEnd () {
      const now = new Date()
      // 最近一周的开始时间，6 天前的同一时刻
      const startDate = new Date(now)
      startDate.setDate(now.getDate() - 6)

      const formatDate = (date) => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        const seconds = String(date.getSeconds()).padStart(2, '0')
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      }

      const formattedStart = formatDate(startDate)
      const formattedEnd = formatDate(now)

      return [formattedStart, formattedEnd]
    },
    // 改变车辆
    changeCL (e) {
      let json = this.carList.filter(item => item.vhcNo == this.addForm.vhcNo)
      this.$set(this.addForm, 'vhcId', json[0].id)
    },
    // 删除文件
    remove (file) {
      if (file.id) {
        this.delId.push(file.id)
      }
    },
    // 添加
    addFn () {
      this.isAdd = true
      this.addFlag = true
    },
    // 修改
    editFn  (row, flag) {
      this.JCimgList = []
      this.HCimgList = []
      if (flag == 1) {
        getCVehicleInfoListByDriverId({ driverId: row.driverId }).then(res => {
          this.carList = res
        })
        getFileShow({ businessId: row.id, businessType: 'workRecordSb' }).then(res => {
          res.forEach(item => {
            this.JCimgList.push({ status: 'ready', url: item.fileKeyUrl, id: item.fileId })
          })
        })
        getFileShow({ businessId: row.id, businessType: 'workRecordXb' }).then(res => {
          res.forEach(item => {
            this.HCimgList.push({ status: 'ready', url: item.fileKeyUrl, id: item.fileId })
          })
        })
        this.title = '修改'
      } else {
        this.title = '下线'
      }
      this.addForm = row
      this.czFlag = flag
      this.addFlag = true
    },
    saveFn () {
      if (this.addForm.attendanceStates == 1) {
        if (this.addForm.sbKilometres > this.addForm.xbKilometres) {
          this.$alert('接车公里数不能大于还车公里数', '系统提示')
          return
        }
        if (this.addForm.sbTime > this.addForm.xbTime) {
          this.$alert('上线时间不能晚于下线时间', '系统提示')
          return
        }
      }

      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let imgfile = new FormData()
          this.addForm.deleteAttachmentsIds = this.delId
          imgfile.set('params', JSON.stringify(this.addForm))
          if (this.czFlag == 1) {
            this.JCimgList.forEach(item => {
              if (!item.id) {
                imgfile.append('filesSb', item.raw)
              }
            })
            this.HCimgList.forEach(item => {
              if (!item.id) {
                imgfile.append('filesXb', item.raw)
              }
            })
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            upWorkRecordPc(imgfile).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.addFlag = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            this.HCimgList.forEach(item => {
              if (!item.id) {
                imgfile.append('files', item.raw)
              }
            })
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            upWorkRecordForXbPc(imgfile).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.addFlag = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        delWorkRecord({
          id: row.id, driverId: row.driverId
        }).then(res => {
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 导出
    exportFn () {
      if (this.searchFrom.sbTime) {
        this.searchFrom.sbTime1 = this.searchFrom.sbTime[0]
        this.searchFrom.sbTime2 = this.searchFrom.sbTime[1]
      } else {
        this.searchFrom.sbTime1 = ''
        this.searchFrom.createTimeEnd2 = ''
      }
      if (this.searchFrom.xbTime) {
        this.searchFrom.xbTime1 = this.searchFrom.xbTime[0]
        this.searchFrom.xbTime2 = this.searchFrom.sbTime[1]
      } else {
        this.searchFrom.xbTime1 = ''
        this.searchFrom.xbTime2 = ''
      }
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      exportExcel(
        this.global.driverNameT + '/cDriverShebao/exportDriverShebaoList',
        form,
        '司机shebao 列表'
      )

      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      if (this.searchFrom.sbTime) {
        this.searchFrom.sbTime1 = this.searchFrom.sbTime[0]
        this.searchFrom.sbTime2 = this.searchFrom.sbTime[1]
      } else {
        this.searchFrom.sbTime1 = ''
        this.searchFrom.createTimeEnd2 = ''
      }
      if (this.searchFrom.xbTime) {
        this.searchFrom.xbTime1 = this.searchFrom.xbTime[0]
        this.searchFrom.xbTime2 = this.searchFrom.sbTime[1]
      } else {
        this.searchFrom.xbTime1 = ''
        this.searchFrom.xbTime2 = ''
      }
      this.loading = true
      cDriverWorkRecordListPC(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        this.loading = false
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.searchFn()
    },
    closeDialog () {
      this.addForm = {
        deleteAttachmentsIds: []
      }
      this.imgLis = []
    }
  }

}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width:340px!important;
}
/deep/.el-form{
  width: 100%;
}

.imgBox{
  margin:0;
}

.inpBox .dzBox  /deep/.el-input__inner {
    width: 190px;
}
.remark  /deep/.el-input .el-input__inner {
    width: 480px;
    height: 80px;
}
/deep/.jiaoyan  .el-input__inner {
    width: 200px;
}
.jiaoyan .el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
</style>
